<template>
    <div
        class="preloader-wrapper"
        v-show="preloaderStatus || value"
        :class="[fixed ? 'fixed' : '', opacity ? 'opacity' : '']"
        :style="compStyle">
        <div class="preloader-double-bounce">
            <div class="preloader-child preloader-double-bounce1"></div>
            <div class="preloader-child preloader-double-bounce2"></div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    preloaderStatus: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Boolean,
      default: () => false,
    },
    fixed: {
      type: Boolean,
      default: () => false,
    },
    opacity: {
      type: Boolean,
      default: () => false,
    },
    background: {
      type: String,
    },
  },
  computed: {
    compStyle () {
      const out = Object();
      if (this.background) {
        out.background = this.background;
      }
      return out;
    },
  },
});
</script>
<style lang="scss">
.preloader-wrapper {
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    left: 0px;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: #EDEDED;
    z-index: 50;

    &.fixed {
        position: fixed;
    }

    &.opacity {
        background: rgba(237, 237, 237, .3);
    }
}

.preloader-double-bounce {
    width: 60px;
    height: 60px;
    position: relative;
    margin: 80px auto;

    .preloader-child {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 50%;
        background-color: $color-blue;
        opacity: 0.6;
        animation: preloader-doubleBounce 2s infinite $transition;
    }

    .preloader-double-bounce2 {
        animation-delay: -1.5s;
    }
}

@-webkit-keyframes preloader-doubleBounce {
    0%, 100% {
        transform: scale(0);
    }
    50% {
        transform: scale(1);
    }
}

@keyframes preloader-doubleBounce {
    0%, 100% {
        transform: scale(0);
    }
    50% {
        transform: scale(1);
    }
}

</style>
